import { amazonHost } from "../../paths";

export default amazonHost + "landing/home-office.jpg";
